import { Injectable } from '@angular/core';
import { HttpClientProtectedService } from '@core/services/auth/http-client-protected.service';
import { Rotas } from '@core/enums/routes';
import { Observable } from 'rxjs';
import {
	RelatorioVariavelEstacao,
	RelatorioDirecaoVentoEstacao,
} from '@home/submodulos/dados-meteorologicos/submodulos/monitoramento/pages/variaveis/interfaces/estacao-ultimas-medicoes';
import ZonedDateTime from '@utils/date/zoned-datetime';
import { VariavelAcompanhamentoColeta } from '../pages/variaveis/interfaces/variaveis';

@Injectable({
	providedIn: 'root',
})
export class VariaveisService {
	constructor(private http: HttpClientProtectedService) {}

	medicoesPersonalizada(
		body: {
			diaInicio: ZonedDateTime;
			diaFim: ZonedDateTime;
		},
		variavel: string
	): Observable<RelatorioVariavelEstacao[]> {
		return this.http.post(
			Rotas.ACOMPANHAMENTO_COLETA + `/medicoes-personalizada/${variavel}`,
			body
		);
	}

	getUltimasMedicoes(
		janelaTempo: number,
		variavel: string
	): Observable<RelatorioVariavelEstacao[]> {
		return this.http.get(
			`${Rotas.ACOMPANHAMENTO_COLETA}/ultimas-medicoes/${variavel}?janelaTempo=${janelaTempo}`
		);
	}

	getMedicoesDeVariavel(
		variavel: VariavelAcompanhamentoColeta,
		dataInicio: Date,
		dataFim: Date,
		periodo: string
	): Observable<RelatorioVariavelEstacao[]> {
		return this.http.get(
			`${Rotas.ACOMPANHAMENTO_COLETA}/medicoes/variavel/${variavel}`,
			{
				dataInicio: dataInicio.toISOString(),
				dataFim: dataFim.toISOString(),
				periodo: periodo,
			}
		);
	}
	getMedicoesdeVariavelPorEstacao(
		variavel: VariavelAcompanhamentoColeta,
		dataInicio: Date,
		dataFim: Date,
		estacaoId: number,
		periodo: string
	): any {
		return this.http.get(
			`${Rotas.ACOMPANHAMENTO_COLETA}/medicoes/variavel/${variavel}/${estacaoId}`,
			{
				dataInicio: dataInicio.toISOString(),
				dataFim: dataFim.toISOString(),
				periodo: periodo,
			}
		);
	}

	getMedicoesDeVentoPorEstacao(
		variavel: VariavelAcompanhamentoColeta,
		dataInicio: Date,
		dataFim: Date,
		estacaoId: number,
		periodo: string
	): Observable<RelatorioDirecaoVentoEstacao[]> {
		return this.http.get(
			`${Rotas.ACOMPANHAMENTO_COLETA}/medicoes/vento/${variavel}/${estacaoId}`,
			{
				dataInicio: dataInicio.toISOString(),
				dataFim: dataFim.toISOString(),
				periodo: periodo,
			}
		);
	}
}
